import { resourceType } from 'constants/loading';
import { findResource } from 'loading/finders';

import { fetchDeviceList, fetchPreferredDevice, fetchDriveDevices } from 'devices/loaders';
import { processDeviceList, processPreferredDevice, processDriveDevices } from 'devices/processors';
import { parseDeviceList, parsePreferredDevice } from 'devices/deviceParser';

import { 
  getDeviceList, 
  getPreferredDevice, 
  getDriveDevices
} from 'devices/selectors';

import { getActiveUserId, getActiveOperationUuid } from 'current/selectors';

export const findDeviceList = ({ dispatch, getState, forceReload=false, forceWait=false, onError }) => {
  const userId = getActiveUserId(getState());
  const resourceSpec = {
    type: resourceType.DEVICE_LIST,
    selector: () => getDeviceList(getState()),
    fetcher: () => fetchDeviceList({ userId, state: getState() }),
    processor: ( raw ) => processDeviceList({ dispatch, getState, deviceList: parseDeviceList(raw) })
  };

  return findResource({ dispatch, getState, forceReload, forceWait, onError, ...resourceSpec });
};

export const findPreferredDevice = ({ dispatch, getState, forceReload=false, forceWait=false, onError }) => {
  const userId = getActiveUserId(getState());
  const operationUuid = getActiveOperationUuid(getState());
  const resourceSpec = {
    type: resourceType.PREFERRED_DEVICE,
    selector: () => getPreferredDevice(getState()),
    fetcher: () => fetchPreferredDevice({ userId, operationUuid }),
    processor: ( raw ) => processPreferredDevice({ dispatch, getState, preferredDevice: parsePreferredDevice(raw) })
  };

  return findResource({ dispatch, getState, forceReload, forceWait, onError, ...resourceSpec });
};

export const findDriveDevices = ({ dispatch, getState, forceReload=false, forceWait=false }) => {
  const userId = getActiveUserId(getState());
  const resourceSpec = {
    type: resourceType.DRIVE_DEVICES,
    selector: () => getDriveDevices(getState()),
    fetcher: () => fetchDriveDevices(userId),
    processor: (raw) => processDriveDevices({ dispatch, getState, driveDevices: raw })
  };

  return findResource({ dispatch, getState, forceReload, forceWait, ...resourceSpec });
};
